import { useSyncExternalStore } from "react";

function subscribe(callback: () => void) {
    window.addEventListener("resize", callback);

    return () => {
        window.removeEventListener("resize", callback);
    };
}

export const useMinWidth = (width: number) => {
    return useSyncExternalStore(subscribe, () => window.matchMedia(`(min-width: ${width}px)`).matches);
};
